import { Space } from 'antd';
import { FC, PropsWithChildren } from 'react';

const InputGroup: FC<PropsWithChildren & { style?: React.CSSProperties }> = ({
  children,
  style,
}) => <Space.Compact style={{ width: '100%', ...style }}>{children}</Space.Compact>;

export default InputGroup;
